import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';

document.addEventListener('readystatechange', () => {
    if (document.readyState !== 'complete') return;

    const isMobile = window.innerWidth <= 576;

    const swiper = new Swiper('.swiper-container', {
        autoHeight: isMobile, //enable auto height
        modules: [Navigation, Pagination, EffectFade],
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        autoplay: isMobile
            ? false
            : {
                  delay: 8500,
                  disableOnInteraction: true,
              },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
